import React, { useEffect, FC, PropsWithChildren } from 'react';

interface Props {
  pushToDataLayer: () => void;
}

export const DataLayerWrapper: FC<PropsWithChildren<Props>> = (props) => {
  const { children, pushToDataLayer } = props;

  useEffect(() => {
    pushToDataLayer();
  }, [pushToDataLayer]);

  return <>{children}</>;
};
